import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useMantineTheme, Box } from '@mantine/core';
import Trans from 'next-translate/Trans';

import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';
import { IconMail } from '~/domains/design-system/icons/IconMail';

import useStyles from './PasswordActions.styles';

function ResetPasswordConfirmation({ email, copy }: { email?: string; copy?: string }) {
  const { classes } = useStyles();
  const { t } = useTranslation('auth');
  const theme = useMantineTheme();

  return (
    <div className={classes.container}>
      <div className={classes.resetPassword}>
        <IconMail size={52} color={theme.colors.blue[4]} />
        <Title variant="display-headline-expanded-xxl" align="center" color={theme.colors.gray2[6]}>
          {t('forgotPassword.linkSentTitle')}
        </Title>
        {copy && (
          <Text
            variant="body-x-large"
            align="center"
            color={theme.colors.gray2[4]}
            mb={theme.other.spacing._8}
          >
            {copy}
          </Text>
        )}

        <Text variant="body-x-large" align="center" color={theme.colors.gray2[4]}>
          {email ? (
            <Trans
              i18nKey="auth:forgotPassword.linkSentSubtitle"
              components={{
                text: (
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore Children are injected via <Trans> component
                  <Text className={classes.emailLink} variant="body-x-large" />
                ),
              }}
              values={{
                email,
              }}
            />
          ) : (
            t('forgotPassword.linkSentNoEmailSubtitle')
          )}
        </Text>
      </div>
    </div>
  );
}

export default ResetPasswordConfirmation;
